import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import ColorsContext from './ColorsContext';
import { getDefaultDate, setLongmonyr } from './routines';
import RegionHeader from './RegionHeader';

function UsgsStation(props) {
    const { sfgw="sf", areaType } = props;
	const [ stationData, setStationData ] = useState(null);
    const { levelColors } = useContext(ColorsContext);
    const monyr = props.date ? props.date: getDefaultDate();

    const dataFileNameBase = areaType === "region" ? "station_" : `station_${areaType}_`;
    const dataFileName = (props.match ? ".." : ".") + "/data/" + dataFileNameBase + sfgw + "_" + monyr + ".json";
    const longmonyr = setLongmonyr(monyr);
    const sfgwTitle = sfgw === 'gw' ? "Groundwater" : "Streamflow";
    const units = sfgw === 'gw' ? "ft below ground surface" : "cfs";
    const col3head = sfgw === 'gw' ? "Date" : "Daily value count";
    const buttontext = "View summary";
	const buttonValue = () => {
        if (sfgw === 'gw') {
             return monyr.length === 7 ? (areaType === 'region' ? "gwregion" : `gw${areaType}`) : (areaType === 'region' ? "gwwkregion" : `gwwk${areaType}`);
        } else {
            return monyr.length === 7 ? (areaType === 'region' ? "sfregion" : `sf${areaType}`) : (areaType === 'region' ? "sfwkregion" : `sfwk${areaType}`);
        }
    }
    
    let droughtRegions = [
        "Western",
        "Connecticut River",
        "Central",
        "Northeast",
        "Southeast",
    ];

    if (sfgw === 'gw') {
        droughtRegions.push("Cape Cod","Islands");
    };
    if (sfgw === 'sf') {
        droughtRegions.push("Cape Cod");
    };
        
    const basins = [
		"Blackstone",
		"Boston Harbor",
		"Buzzards Bay",
		"Cape Cod",
		"Charles",
		"Chicopee",
		"Connecticut",
		"Deerfield",
		"Farmington",
		"French",
		"Housatonic",
		"Hudson",
		"Ipswich",
		"Islands",
		"Merrimack",
		"Millers",
		"Narragansett Bay",
		"Nashua",
		"North Coastal",
		"Parker",
		"Quinebaug",
		"Shawsheen",
		"South Coastal",
		"SuAsCo",
		"Taunton",
		"Ten Mile",
		"Westfield"
	];

    const counties = [
        "Barnstable",
        "Berkshire",
        "Bristol",
        "Dukes",
        "Essex",
        "Franklin",
        "Hampden",
        "Hampshire",
        "Middlesex",
        "Nantucket",
        "Norfolk",
        "Plymouth",
        "Suffolk",
        "Worcester"
    ];

    var droughtAreas = null;
    switch (areaType) {
      case 'region':
        droughtAreas = droughtRegions;
        break;
      case 'basin':
        droughtAreas = basins;
        break;
      case 'county':
        droughtAreas = counties;
        break;
      default:
        console.log(`Bad areaType selection - ${areaType}`);
        droughtAreas = droughtRegions;
    }

    const getStnData = () => { 
		axios.get(dataFileName)
		.then(results => {
            setStationData(results.data.data);
		})
		.catch(err => {
			console.log("Station Data Error: " + err);
		});
	}

	useEffect(() => {
		getStnData();
		 // eslint-disable-next-line
	}, [])


	return (
        <>
        	<RegionHeader
				title={sfgwTitle}
				buttontext={buttontext}
				buttonValue={buttonValue()}
				handleButtonClick={props.handleButtonClick}
			/>
            {stationData &&
                <div style={{overflowX:"auto"}}>
                    <table className="pcpnTable-container">
                        <caption>
                            {longmonyr} {longmonyr.search(",") < 0 ? "Monthly" : ""} {sfgwTitle+" Percentiles"}
                        </caption>      
                        <thead>
                            <tr>
                                <td colSpan="6">
                                    <table className="tableLegend-container">
                                        <tbody>
                                            <tr>
                                                <td className="tableLegend-heading" colSpan="5">Shading indicates index severity level:</td>
                                            </tr>
                                            <tr>
                                                <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[0]}}>Level 0</td>
                                                <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[1]}}>Level 1</td>
                                                <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[2]}}>Level 2</td>
                                                <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[3]}}>Level 3</td>
                                                <td className="tableLegend-value-container" style={{"backgroundColor":levelColors[4], "color":"white"}}>Level 4</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <th scope="col">{areaType[0].toUpperCase() + areaType.slice(1) + "/Site"}</th>
                                <th scope="col">ID</th>
                                <th scope="col">{sfgwTitle+" ("+units+")"}</th>
                                <th scope="col">{col3head}</th>
                                <th scope="col">Period of record</th>
                                <th scope="col">{sfgwTitle+" Percentile"}</th>
                            </tr>
                        </thead>
                        <tbody className="stnTable-container">
                            {droughtAreas.map((rd, i) => (                           
                                <React.Fragment key={"f"+i}>
                                    <tr key={i}>
                                        <th colSpan="6" scope="row">{rd.replace("Connecticut River","CTRV")}</th>
                                    </tr>
                                    {Object.keys(stationData[rd]).map((stn, j) => (
                                        <tr key={i+"stn"+j}>
                                            <td>{stationData[rd][stn].name}</td>
                                            <td>{stationData[rd][stn].id}</td>
                                            <td>{stationData[rd][stn] ? stationData[rd][stn].value.toFixed(2) : "-"}</td>
                                            <td>{sfgw === 'gw' ? stationData[rd][stn].mdate.replace("-","/") : stationData[rd][stn].value_count}</td>
                                            <td>{stationData[rd][stn].por_start} - {stationData[rd][stn].por_end}</td>
                                            <td style={{
                                                backgroundColor: stationData[rd][stn] ? levelColors[stationData[rd][stn].level] : "white",
                                                color: stationData[rd][stn] && stationData[rd][stn].level === 4 ? "white" : "black"
                                            }}>
                                                {stationData[rd][stn] ? stationData[rd][stn].pctl : "-"}
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
        </>
	);
}

export default UsgsStation
